import React, { useState } from "react";
import {
  TopBar,
  DocumentDetails,
  ResultsFooterBar,
  SearchProvider,
  ResultsPanel,
} from "../components/common";
import NavBar from "../components/layout/NavBar";
import SearchSidebar from "../components/sidebar/SearchSidebar";

function SidebarResizeHandle() {
  const onMouseDown = (e) => {
    e.preventDefault();
    const root = document.documentElement;
    const startX = e.clientX;
    const startW = parseInt(
      getComputedStyle(root).getPropertyValue("--sidebar-width").trim() || "243",
      10,
    );
    const onMove = (ev) => {
      const dx = ev.clientX - startX; // dragging right increases width
      const next = Math.min(Math.max(startW + dx, 160), 480);
      root.style.setProperty("--sidebar-width", next + "px");
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };
  return <div className="sidebar-resizer" onMouseDown={onMouseDown} />;
}

export default function Home() {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try { return localStorage.getItem("sidebar_open") !== "0"; } catch { return true; }
  });

  const toggleSidebar = () => {
    setSidebarOpen(prev => {
      const next = !prev;
      try { localStorage.setItem("sidebar_open", next ? "1" : "0"); } catch {}
      return next;
    });
  };

  return (
    <SearchProvider>
      <div className="app-root">
        <div className="nav-strip">
          <NavBar />
        </div>
        <TopBar />
        <div className={`main-layout${sidebarOpen ? "" : " main-layout--sidebar-collapsed"}`}>
          <nav className={`side-panel${sidebarOpen ? "" : " side-panel--collapsed"}`}>
            <button
              className="sidebar-toggle"
              onClick={toggleSidebar}
              title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
            >
              {sidebarOpen ? "‹" : "›"}
            </button>
            {sidebarOpen && <SidebarResizeHandle />}
            {sidebarOpen && (
              <div className="side-panel-content">
                <SearchSidebar />
              </div>
            )}
          </nav>
          <main className="center-panel">
            <ResultsPanel />
          </main>
          <DocumentDetails />
          <ResultsFooterBar />
        </div>
      </div>
    </SearchProvider>
  );
}
